import { IoMdClose } from "react-icons/io";
import styles from "./Modal.module.scss";
import React, { useEffect } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  showCloseIcon?: boolean;
}

function Modal(props: Props) {
  const { isOpen, setIsOpen, children, showCloseIcon = true } = props;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <div
      className={`${styles.mainContainer} ${isOpen ? styles.mainContainerActive : ""}`}
    >
      {isOpen && (
        <div className={styles.contentContainer}>
          {children}
          {showCloseIcon && (
            <div className={styles.iconContainer}>
              <IoMdClose
                className={styles.icon}
                size={15}
                onClick={() => setIsOpen(false)}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Modal;
